import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { BLOGS, BLOG_CATEGORIES } from "../data/blogs";

const Blog = () => {
  const [cat, setCat] = useState("All");
  const filtered = useMemo(
    () => (cat === "All" ? BLOGS : BLOGS.filter((b) => b.category === cat)),
    [cat]
  );
  const featured = BLOGS[0];

  return (
    <main className="bg-[#F4EFE8]">
      {/* HERO */}
      <section className="bg-[#EDE6DC] py-16 md:py-24">
        <div className="max-w-[1100px] mx-auto px-5 md:px-8 text-center">
          <p className="text-[12px] tracking-[0.3em] uppercase text-[#8a6d3b] mb-4">The FlowLux Journal</p>
          <h1 className="font-serif-display text-[42px] md:text-[64px] leading-[1.02] font-medium mb-5">
            Informational Blogs
          </h1>
          <p className="text-[15px] md:text-[17px] text-[#1A1A1A]/70 max-w-2xl mx-auto leading-relaxed">
            Dermatologist-backed guides on red light therapy, skincare science, and building a glow-worthy routine — written to help you make smarter, more confident decisions about your skin.
          </p>
        </div>
      </section>

      {/* FEATURED */}
      <section className="max-w-[1280px] mx-auto px-5 md:px-8 py-12 md:py-16">
        <Link to={`/blog/${featured.slug}`} className="group grid md:grid-cols-2 gap-8 items-center bg-white rounded-md overflow-hidden border border-[#1A1A1A]/10 hover:shadow-[0_28px_60px_-30px_rgba(26,26,26,0.4)] transition-shadow duration-500">
          <div className="overflow-hidden h-full">
            <img src={featured.image} alt={featured.title} className="w-full h-full min-h-[280px] object-cover group-hover:scale-105 transition-transform duration-700" />
          </div>
          <div className="p-8 md:p-12">
            <span className="inline-block text-[11px] tracking-[0.18em] uppercase text-[#6D28D9] font-semibold mb-4">
              Featured • {featured.category}
            </span>
            <h2 className="font-serif-display text-[30px] md:text-[40px] leading-[1.08] font-medium mb-4">
              {featured.title}
            </h2>
            <p className="text-[15px] text-[#1A1A1A]/70 leading-relaxed mb-6">{featured.excerpt}</p>
            <div className="flex items-center gap-4 text-[12px] text-[#1A1A1A]/50 mb-6">
              <span>{featured.date}</span>
              <span className="flex items-center gap-1"><Clock size={13} /> {featured.readTime}</span>
            </div>
            <span className="inline-flex items-center gap-2 text-[12px] tracking-[0.2em] uppercase border-b border-[#1A1A1A] pb-1 group-hover:gap-4 transition-all">
              Read Article <ArrowRight size={15} />
            </span>
          </div>
        </Link>
      </section>

      {/* FILTERS */}
      <section className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="flex flex-wrap gap-3 justify-center pb-10 border-b border-[#1A1A1A]/10">
          {BLOG_CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              className={`px-5 py-2 text-[11px] tracking-[0.16em] uppercase rounded-full border transition-colors ${
                cat === c
                  ? "bg-[#1A1A1A] text-[#F4EFE8] border-[#1A1A1A]"
                  : "bg-transparent text-[#1A1A1A]/70 border-[#1A1A1A]/25 hover:border-[#1A1A1A]"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </section>

      {/* GRID */}
      <section className="max-w-[1280px] mx-auto px-5 md:px-8 py-12 md:py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {filtered.map((b) => (
            <Link
              key={b.slug}
              to={`/blog/${b.slug}`}
              className="group flex flex-col bg-white rounded-md overflow-hidden border border-[#1A1A1A]/10 hover:shadow-[0_24px_50px_-30px_rgba(26,26,26,0.4)] transition-shadow duration-500"
            >
              <div className="overflow-hidden">
                <img src={b.image} alt={b.title} className="w-full h-52 object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <span className="text-[10px] tracking-[0.18em] uppercase text-[#6D28D9] font-semibold mb-3">{b.category}</span>
                <h3 className="font-serif-display text-[22px] leading-snug font-medium mb-3 group-hover:text-[#6D28D9] transition-colors">{b.title}</h3>
                <p className="text-[13px] text-[#1A1A1A]/65 leading-relaxed flex-1">{b.excerpt}</p>
                <div className="flex items-center gap-3 text-[11px] text-[#1A1A1A]/45 mt-5 pt-4 border-t border-[#1A1A1A]/10">
                  <span>{b.date}</span>
                  <span className="flex items-center gap-1"><Clock size={12} /> {b.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Blog;
